export default "__VITE_ASSET__DhSsTWwk__"